export default "__VITE_ASSET__Dkclhf72__"